import React from 'react';
import PropTypes from 'prop-types';

import t from '../../../lib/I18n';

import BaseModal from '../../general/BaseModal';

const RewardPointsModal = ({ onClose }) => {
    return (
        <BaseModal
            className="modal--sm reward-points__modal"
            onClose={onClose}
            titleText={t('rewardPoints.modal.title')}
            hideContinue
        >
            <h3>{t('rewardPoints.modal.heading')}</h3>
            <p>{t('rewardPoints.modal.schemeEnding')}</p>
            <p>{t('rewardPoints.modal.existingRewardCodes')} <a target="_blank" href="https://www.nextlevelrewards.co.uk/">(Next Level Rewards)</a> {t('rewardPoints.modal.existingRewardCodesUntil')}</p>
        </BaseModal>
    );
};

RewardPointsModal.propTypes = {
    onClose: PropTypes.func,
};

export default React.memo(RewardPointsModal);
